import { format } from 'date-fns';
import React from 'react';
import { TextField } from '@material-ui/core';
function isDateValid(date) {
    return !!(date && !isNaN(+new Date(date)));
}
function getDateValue(d, dateOnly) {
    const df = 'yyyy-MM-dd';
    return d && isDateValid(d)
        ? format(new Date(d), dateOnly ? df : `${df}'T'HH:mm:00`)
        : '';
}
export const EntityDateField = ({ column, value, plugin, label, placeholder, helperText, error, onChange }) => {
    var _a, _b;
    const validationError = (_b = (_a = plugin.edit) === null || _a === void 0 ? void 0 : _a.validateError) === null || _b === void 0 ? void 0 : _b.call(_a, column, value);
    const dateOnly = column.type === 'date';
    return (React.createElement(TextField, { className: 'entity-field', fullWidth: true, size: 'small', 
        // disabled={disabled}
        variant: 'outlined', defaultValue: getDateValue(value, dateOnly), label: label, placeholder: placeholder || dateOnly ? 'Pick a date' : 'Pick a date & time', error: Boolean(error) || Boolean(validationError), helperText: validationError || helperText, InputLabelProps: { shrink: true }, type: dateOnly ? 'date' : 'datetime-local', onChange: event => {
            const { value } = event.target;
            const date = value && getDateValue(value, dateOnly);
            onChange === null || onChange === void 0 ? void 0 : onChange(date);
        } }));
};
//# sourceMappingURL=EntityDateField.js.map